import(/* webpackMode: "eager" */ "/vercel/path0/src/app/eligibility-checker/page.tsx");
